import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                'primary': '#008BBF',
                'btn-color' : '#00D2EA',
                'secondary': '#5170b5',
                'accent': '#f2eff9',
                'error': '#FF5252',
                'info': '#2196F3',
                'success': '#4CAF50',
                'warning': '#FFC107',
                'progress-bar-color' : '#FEC101',
                'card-color' : '#EEEEEE'
            },
            dark: {
                primary: '#f06a25',
                secondary: '#5170b5',
                accent: '#f06a25',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            },
        },
    },
    lang: {
        locales: { es },
        current: 'es',
    },
    icons: {
        iconfont: 'fa',
    },
});